import { ICustomePhoneNumberInput } from "./type"
import styles from './customePhoneNumberInput.styles.module.scss'
import Input from 'react-phone-number-input/input';
import { E164Number } from 'libphonenumber-js/types'

const CustomPhoneNumberInput = (props: ICustomePhoneNumberInput) => {
    const { required, label, placeholder, className, value, onChangePhoneNumber } = props
    const handleChange = (number?: E164Number | undefined) => {
        if (onChangePhoneNumber) {
            onChangePhoneNumber(number)
        }
    }
    return (
        <div className={`${styles.customePhoneNumberInput}`}>
            <label className="form-label">
                {label}
                {required && <span className={styles.requiredSing}>*</span>}
            </label>
            <Input
                className={`form-control ${className ? className : ''}`}
                country={"IN"}
                value={value}
                placeholder={placeholder}
                onChange={handleChange}
            />
        </div>
    )
}

export default CustomPhoneNumberInput